import { CreateFocusCss } from '../../../../styles'
import colors from '../../../../theming/docusign-themes/olive/colors'
import type { Tokens } from '../../../../theming/types'
import type { PopoverCloseProps } from '..'

export default (config: {
  tokens: Tokens
  props: Pick<PopoverCloseProps, 'isForOverlay'>
}) => {
  const { tokens, props } = config
  const { isForOverlay } = props

  return {
    default: {
      wrap: {
        button: {
          ...(isForOverlay
            ? {
                alignItems: 'center',
                background: colors.gray3,
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'inline-flex',
                height: '32px',
                justifyContent: 'center',
                width: '32px',
                transitionDuration: '0.2s',
                transitionProperty: 'background, border',
                transitionTimingFunction: 'ease',

                '& svg': {
                  fill: tokens.iconColorDefault,
                  transition: 'fill 0.2s ease',
                },

                '&:hover': {
                  background: colors.funBlue,
                },

                '&:hover svg': {
                  fill: colors.white,
                },

                ...CreateFocusCss(tokens.focusOuter),
              }
            : {
                background: 'none',

                '&:hover': {
                  color: '#666666',
                },
              }),
        },
      },
    },

    dark: {
      wrap: {
        button: {
          ...(isForOverlay
            ? {
                backgroundColor: colors.black,

                '& svg': {
                  fill: colors.white,
                },

                '&:hover': {
                  backgroundColor: colors.gray3,
                },

                '&:active': {
                  backgroundColor: colors.gray3,
                },

                '&:hover svg': {
                  fill: colors.gray8,
                },
              }
            : {
                color: 'white',

                '&:hover': {
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                },

                '&:active': {
                  backgroundColor: 'rgba(255, 255, 255, 0.35)',
                },
              }),
        },
      },
    },
  } as const
}
